import { Box, FormLabel } from "@mui/material";
import TooltipPopover from "../../../../components/shared/others/TooltipPopover";

const TooltipNumber = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <FormLabel sx={{ color: 'text.primary' }}><b> Número </b></FormLabel>
            <TooltipPopover>
                Gerado automaticamente pelo sistema após a criação da fatura,
                este identificador único e sequencial facilita o controle, a organização e o
                rastreamento de todas as cobranças emitidas. Por isso, não pode ser editado manualmente.
            </TooltipPopover>
        </Box>
    )
}

export default TooltipNumber;